import { defineContent } from './defineContent.js';
import data from './stats.json';
import { statsSchema } from './stats.schema.js';

export const stats = defineContent(statsSchema, data);
